import React, { useEffect, useState, useRef } from 'react';
import UI_Input_Text from './UI_Input_Text';
import UI_Icon from './UI_Icons';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Divider from './UI_Divider';
import UI_Button from './UI_Button';

export default function UI_Input_Time({
    id,
    Label_Text,
    onInput,
    onSubmit,
    onKeyDown,
    Value,
    Value_Set_Enable,
    onChange,
    onBlur,
    onClick,
    autoFocus,
    onFocus,
    disabled,
    Classes,
    min,
    max,
    PreventPast,
    Required,
    name
}) {
    const Parse = (Value) => {
        if (!Value) return { Hours: 12, Minutes: 0, AMPM: "AM" };
        let [H, M] = Value.split(":").map(Number);
        let AMPM = H >= 12 ? "PM" : "AM";
        if (H === 0) H = 12;
        else if (H > 12) H -= 12;
        return {
            Hours: H.toString().padStart(2, "0"),
            Minutes: M.toString().padStart(2, "0"),
            AMPM
        };
    };
    const Initial = Parse(Value);
    const [Hours, Hours_Set] = useState(Initial.Hours.toString().padStart(2, "0"));
    const [Minutes, Minutes_Set] = useState(Initial.Minutes.toString().padStart(2, "0"));
    const [AMPM, AMPM_Set] = useState(Initial.AMPM);
    const [Time_Display, Time_Display_Set] = useState(`${Hours.toString().padStart(2, "0")}:${Minutes.toString().padStart(2, "0")} ${AMPM}`);
    const [Time_Display_Raw, Time_Display_Raw_Set] = useState(`${Hours.toString().padStart(2, "0")}:${Minutes.toString().padStart(2, "0")}`);
    const [Flyout_Display, Flyout_Display_Set] = useState(false);
    const [Flyout_Display_Render, Flyout_Display_Render_Set] = useState(false);
    const Wrapper_Ref = useRef();
 
    const Handle_Click = () => {
        Flyout_Display_Set(!Flyout_Display);
        if (onClick) {
            onClick();
        }
    }

    useEffect(() => {
        if (!Flyout_Display) {
            if (id) {
                document.getElementById(id).focus();
            }
            setTimeout(() => {
                Flyout_Display_Render_Set(Flyout_Display);
            }, 200)
        } else {
            Flyout_Display_Render_Set(Flyout_Display);
        }

    }, [Flyout_Display])

    const Handle_Change = (Element, Target) => {
        if (Target === "Hours") {
            let h = parseInt(Element.target.value) || 0;
            if (h > 12) h = 1;
            if (h < 1) h = 12;
            Hours_Set(h.toString().padStart(2, "0"));
        }
        if (Target === "Minutes") {
            let m = parseInt(Element.target.value) || 0;
            if (m > 59) m = 0;
            if (m < 0) m = 59;
            Minutes_Set(m.toString().padStart(2, "0"));
        }
    }

    const Handle_Switch = (Value) => {
        AMPM_Set(Value);
    }

    useEffect(() => {
        const Time_Formatted = `${Hours.toString().padStart(2, "0")}:${Minutes.toString().padStart(2, "0")} ${AMPM}`;
        Time_Display_Set(Time_Formatted);
        let Return_Hours = Number(Hours);
        if (AMPM === "PM" && Return_Hours < 12) {
            Return_Hours = Return_Hours + 12;
        }
        Time_Display_Raw_Set(`${Return_Hours.toString().padStart(2, "0")}:${Minutes.toString().padStart(2, "0")}`);

        if (onChange) {
            const Return_Time = `${Return_Hours.toString().padStart(2, "0")}:${Minutes.toString().padStart(2, "0")}`
            // onChange(Return_Time);
            onChange({
                target: {
                    id: id,
                    value: Return_Time
                }
            });
        }
    }, [Hours, Minutes, AMPM]);

    useEffect(() => {
        if (Flyout_Display_Render) {
            document.getElementById(`${id}_Input_Hours`).select();
        }
    }, [Flyout_Display_Render]);

    useEffect(() => {
        const Handle_Outside = (event) => {
            if (Wrapper_Ref.current && !Wrapper_Ref.current.contains(event.target)) {
                Flyout_Display_Set(false);
            }
        };

        document.addEventListener('mousedown', Handle_Outside);

        const Handle_Escape = (e) => {
            if (e.key === "Escape") {
                Flyout_Display_Set(false);
            }
        };
        document.addEventListener('keydown', Handle_Escape);
        return () => {
            document.removeEventListener('mousedown', Handle_Outside);
            document.removeEventListener('keydown', Handle_Escape);
        };
    }, []);

    return (
        <>
            <input
                type="time"
                id={`${id}_Input_Raw`}
                value={Time_Display_Raw}
                readOnly
                hidden
            />
            {Label_Text ? (
                <label className="Input_Label" htmlFor={id}>
                    {Label_Text}{Required ? <p className="Input_Label_Required">*</p> : ""}
                </label>
            ) : null}
            <div className='Input_Time_Wrapper' ref={Wrapper_Ref}>
                <button
                    className='Input_Text Input_Time'
                    id={id}
                    onClick={Handle_Click}
                    type='button'
                    Time={Time_Display_Raw}
                >
                    <p className='General_Paragraph Input_Time_Text'>
                        {Time_Display}
                    </p>
                    <UI_Icon
                        className="Input_Icon"
                        Name="Clock"
                    />
                </button>
                <p className="Input_Text_Prompt" id={`${id}_Prompt`}></p>
                {Flyout_Display_Render ?
                    <div
                        className='Input_Time_Flyout'
                        State={Flyout_Display ? "Active" : "Inactive"}
                        
                    >
                        <p className='General_Paragraph'>
                            Select time
                        </p>
                        <div className='Input_Time_Flyout_Input'>
                            <input
                                type='number'
                                className="Input_Time_Flyout_Input_Component"
                                max={13}
                                min={0}
                                value={Hours}
                                onInput={e => Handle_Change(e, "Hours")}
                                id={`${id}_Input_Hours`}
                            />
                            <h1 className='Input_Time_Flyout_Input_Colon'>
                                :
                            </h1>
                            <input
                                type='number'
                                className="Input_Time_Flyout_Input_Component"
                                max={60}
                                min={-1}
                                value={Minutes}
                                onInput={e => Handle_Change(e, "Minutes")}
                                id={`${id}_Input_Minutes`}
                            />
                            <div className='Input_Time_Flyout_Input_AMPM'>
                                <button
                                    className='Input_Time_Flyout_Input_AMPM_Component'
                                    onClick={() => Handle_Switch("AM")}
                                    State={AMPM === "AM" ? "Active" : "Inactive"}
                                    type='button'
                                >
                                    AM
                                </button>
                                <button
                                    className='Input_Time_Flyout_Input_AMPM_Component'
                                    onClick={() => Handle_Switch("PM")}
                                    State={AMPM === "PM" ? "Active" : "Inactive"}
                                    type='button'
                                >
                                    PM
                                </button>
                            </div>
                        </div>
                        <div>
                            <UI_Button
                                Text="OK"
                                Fill={true}
                                className="Input_Time_Flyout_Button"
                                OnClick={Handle_Click}
                                Type="button"
                            />
                        </div>

                    </div>
                    :
                    ""
                }

            </div>


        </>
    )
}